export enum InventoryStatisticsStatus {
	Valid = 1,
	IncompleteForecast = 2,
	InvalidConfig = 4,
}
